<!--
KeyDate component
@author rb304x
-->
<template>
  <div class="eventDiv eventBox" v-if="keyDate.category">
    <div class="d-flex align-items-start">
      <img alt="" :src="getImage(keyDate.category.name)" class="key-date-icon" />
      <div class="d-flex flex-column pt-2">
        <h3 class="eventHeaderN">{{ title }}</h3>
        <p class="eventBodyN" v-if="keyDate.datesConfirmed == 'true'">{{ keyDateDate }}</p>
        <p class="eventBodyN" v-if="keyDate.datesConfirmed == 'false'">TBC</p>
        <p class="eventCategory">{{ getCategory }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
//Composables
import {ref, computed} from 'vue'
import { useStringUtil } from '@/composables/StringMethods.js'
const { displayKeyDateInfo } = useStringUtil()

//Props
const props = defineProps({
  title: String,
  startDate: Number,
  endDate: Number,
  keyDate: Object
})

//Data
let evinfo = displayKeyDateInfo(props.startDate, props.endDate)
const keyDateDate =  ref(evinfo.date)

//Computed
const getCategory = computed(() => {
  if (props.keyDate.category.name) {
      return props.keyDate.category.name
  } else {
    return ''
  }
})

function getImage (category) {
  var images = require.context('@/assets/keydates/', false, /\.svg$/)
  return images('./' + category + '.svg')
}

function checkMultiDate () {
  // var start = new Date(startDate)
  // var end = new Date(endDate)
  // if (start == end) return false
  // return true
  return false // until we get keyDate end dates
}
</script>

<style scoped>
.eventCategory {
  font-size: 14px;
  color: #666666;
  margin-bottom: 0px;
}
.eventBox {
  border-top: 1px solid #ccc;
  padding: 1rem;
  padding-right: 2rem;
  position: relative;
}

.eventBox:first-child {
  border-top:none;
}

.eventDiv {
  margin-bottom:12px;
  padding: 0.5rem 1rem 0px;
}

.eventBodyN {
  font-size: 1rem;
  color: #1D1D1D;
  margin-bottom: 0.5rem;
  display: block;
}

.eventHeaderN {
  font-weight: bold;
  font-size: 1rem;
  margin-bottom: 0.5rem;
  color: var(--uog-dark-blue);
}

.key-date-icon {
  margin-right: 1rem;
}

.key-date-icon svg rect {
    fill: #fff;
}

.key-date-icon svg path {
    fill: var(--uog-dark-blue);
}
</style>
